import { MessageDownLoadFile, toaster } from '@halo/ui-chat-react';
import { useShallowEnhance } from '@halo/zustand-enhance';
import { useIsMyMsg } from '@/scripts/hooks';
import { useSessionStore, type Msg, type Session } from '@/store/client/store';

export interface MsgFileDownloadProps {
  message: Msg;
  session: Session;
}

export const MsgFileDownload = memo(function MsgFileDownload({
  session,
  message,
}: MsgFileDownloadProps) {
  const { t } = useTranslation();
  const isMyMessage = useIsMyMsg(message);
  const { groupAccess, downloadFile } = useSessionStore(
    session.chat_id,
    useShallowEnhance(['groupAccess', 'downloadFile'])
  );

  const restrictDownloadDisabled = useMemo(() => {
    return !groupAccess?.canRestrictDownload;
  }, [groupAccess?.canRestrictDownload]);

  if (restrictDownloadDisabled) {
    return null;
  }

  return (
    <MessageDownLoadFile
      message={message}
      isMe={isMyMessage}
      onDownload={() =>
        downloadFile(message).then(() => {
          toaster.success({
            title: t('tips.downloadCompleted'),
          });
        })
      }
    />
  );
});
